import * as React from 'react';

import { useLocalStore } from 'hooks/';

import { useBasicFormStore } from '../BasicFormStore';

import { UploadFormStore } from './UploadFormStore';

export const UploadFormStoreContext =
  React.createContext<UploadFormStore | null>(null);

export const UploadFormStoreProvider = ({
  children,
}: React.PropsWithChildren) => {
  const basicStore = useBasicFormStore();

  const store = useLocalStore(() => new UploadFormStore({ basicStore }));

  return (
    <UploadFormStoreContext.Provider value={store}>
      {children}
    </UploadFormStoreContext.Provider>
  );
};

export const useUploadFormStore = () => {
  const context = React.useContext(UploadFormStoreContext);

  if (!context) {
    throw new Error('UploadFormStoreContext is not found');
  }

  return context;
};
